'use strict';

var clientSideValidation = require('lyonscg/components/clientSideValidation');

var exportClientSideValidation = $.extend(clientSideValidation, {
    invalid: function () {
        $('form input, form select, form textarea').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid');
                $(this).siblings('label').addClass('is-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').find('.invalid-feedback')
                    .text(validationMessage);
            }

            // Focus first visible and invalid field on page (for screenreaders and ADA)
            $('form input, form select, form textarea').filter('.is-invalid:visible').first().focus();
        });
    },

    /**
     * Clears the validation errors of an invalidated form element after a change occurs
     */
    clearErrorsOnChange: function () {
        $('body').on('change input', ':input, .form-control', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid');
                $(this).closest('.invalid-feedback').remove();
            }
        });
    }
});

module.exports = exportClientSideValidation;
